module.exports = __webpack_public_path__ + "static/img/station.f0cc8251.png";